import { render, staticRenderFns } from "./tabWithDataList.vue?vue&type=template&id=5c6a33d3&scoped=true&"
import script from "./tabWithDataList.vue?vue&type=script&lang=js&"
export * from "./tabWithDataList.vue?vue&type=script&lang=js&"
import style0 from "./tabWithDataList.vue?vue&type=style&index=0&id=5c6a33d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6a33d3",
  null
  
)

export default component.exports